module.exports = {
  // BACKEND_URL: process.env.REACT_APP_BASE_URL || 'https://cvapi.accelone.com',
  BACKEND_URL: process.env.REACT_APP_BASE_URL || 'http://localhost:4000',
  MAX_PROJECT_DESCRIPTION: process.env.REACT_APP_MAX_PROJECT_DESCRIPTION || 200,
  FULLSEARCH_ONLY: process.env.REACT_APP_FULLSEARCH_ONLY,
};
